<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="cursos || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      :value="value"
      @input="atualizarCurso($event)"
      @change="atualizarCurso($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import AlunoService from "../../../../domain/corpore/AlunoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-todos-curso",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    },
    servicoId: String
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  asyncComputed: {
    cursos() {
      const alunoService = new AlunoService(this.$http);
      let login = this.login !== "" ? this.login : this.usuario.login;

      // 139 - Solicitação - Segunda Via de Carteirinha - Unidade Centro (Graduação e Colégio)
      const filialId = this.servicoId === "139" ? 1 : null;

      if (login) {
        return alunoService
          .getAllCursosAlunoByRa(login, null, filialId)
          .then(result =>
            result.map(curso => ({
              value: curso.CODCURSO,
              text: `${curso.NOME}${curso.STATUS ? ` (${curso.STATUS})` : ""}`,
              codPerlet: curso.CODPERLET,
              periodo: curso.PERIODO
            }))
          )
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    },
    setCurso() {
      if (this.cursos && this.cursos.length === 1) {
        this.$validator.reset();
        this.atualizarCurso(this.cursos[0].value.toString());
      }
    }
  },
  methods: {
    atualizarCurso(value) {
      if (value != null) {
        this.formValues.cursoId = value;
        this.$el.value = value;
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TodosCurso.vue